module.exports = __webpack_public_path__ + "de77a722/img/question-icon.06c20c5d.svg";